<template>
  <div class="product-collect">
    <section-header class="mt-5 mb-5" :title="header.title" :subtitle="header.subtitle"/>
    <product-grid :products="products"/>
  </div>
</template>

<script>
import constant from '@/constant.js'
import { mapMutations } from 'vuex'
import commonApi from '@/api/common.js'
import productApi from '@/api/product.js'
import SectionHeader from '@/components/SectionHeader.vue'
import ProductGrid from '@/components/Product/ProductGrid.vue'

export default {
  name: 'ProductCategory',
  components: {
    SectionHeader,
    ProductGrid
  },
  data: function () {
    return {
      pageBlock: null,
      products: null
    }
  },
  computed: {
    blockId: function () {
      return this.$route.params.id
    },
    header: function () {
      var ret = {
        title: null,
        subtitle: null
      }
      if (this.pageBlock) {
        ret.title = this.pageBlock.title
        ret.subtitle = this.pageBlock.subTitle
      }
      return ret
    },
    productIds: function () {
      return this.pageBlock && this.pageBlock.goodsArray ? this.pageBlock.goodsArray.split(',') : null
    }
  },
  watch: {
    blockId: function (value) {
      this.refresh()
    },
    productIds: function (value) {
      if (value) {
        this.apiGetProducts()
      }
    }
  },
  mounted: function () {
    this.apiGetPageBlock()
  },
  methods: {
    ...mapMutations([
      'signOut'
    ]),
    apiGetPageBlock: function () {
      if (!this.blockId) {
        return
      }
      var self = this
      commonApi.getPageBlock(this.blockId, function (err, rspData) {
        if (err) {
          if (err === constant.API_ERR_AUTH) {
            self.signOut()
          } else {
            alert(`${err}: ${rspData}`)
          }
          return
        }
        if (rspData.goodsArray) {
          self.pageBlock = rspData
        }
      })
    },
    apiGetProducts: function () {
      if (!this.productIds) {
        return
      }
      var self = this
      var count = 0
      var products = []
      this.productIds.forEach((e, i) => {
        productApi.getProduct(e, function (err, rspData) {
          if (err) {
            if (err === constant.API_ERR_AUTH) {
              self.signOut()
            } else {
              alert(`${err}: ${rspData}`)
            }
            return
          }
          products[i] = rspData
          count++
          if (count === self.productIds.length) {
            self.products = products
          }
        })
      })
    },
    refresh: function () {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' })
      this.apiGetPageBlock()
    }
  }
}
</script>

<style scoped>
</style>
